import { render, staticRenderFns } from "./landing-page-section-title.vue?vue&type=template&id=4e8365dd&scoped=true&lang=pug"
import script from "./landing-page-section-title.js?vue&type=script&lang=js&external"
export * from "./landing-page-section-title.js?vue&type=script&lang=js&external"
import style0 from "./landing-page-section-title.vue?vue&type=style&index=0&id=4e8365dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8365dd",
  null
  
)

export default component.exports